export const targets = [
  { id: 'weapp', name: '微信小程序' },
  { id: 'alipay', name: '支付宝小程序' },
  { id: 'swan', name: '百度小程序' },
  { id: 'tt', name: '字节跳动小程序' },
  { id: 'qq', name: 'QQ 小程序' },
  { id: 'jd', name: '京东小程序' },
  { id: 'quickapp', name: '快应用' },
  { id: 'rn', name: 'React Native' },
  { id: 'h5', name: 'H5' },
  { id: 'dd', name: '钉钉小程序' },
  { id: 'qy', name: '企业微信小程序' },
  { id: 'feishu', name: '飞书小程序' },
  { id: 'kwai', name: '快手小程序' },
  { id: 'iot', name: '支付宝 IOT 小程序' },
  { id: 'harmony', name: '鸿蒙' }
]
